import React from 'react';
import ProjectSidebarComponent from './ProjectSidebarComponent';
import { PageHeader } from '../../components';

const CoolingTowersEngineeringConstruction: React.FC = () => {
  return (
    <>
      <PageHeader title="Cooling Towers – Engineering & Construction (E&C)" breadcrumbs={[{ label: "Projects", path: "/projects" }]} />

      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s"
        style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
        <div className="container">
          <div className="row g-5">

            <div className="col-lg-8">
              <div className="row g-3 mb-5">
                <div className="col-md-6">
                  <img className="img-fluid" src="img/industrial-3.jpg" alt="" />
                </div>
                <div className="col-md-6">
                  <img className="img-fluid" src="img/industrial-1.jpg" alt="" />
                </div>
              </div>
              <h1 className="mb-4">Cooling Towers – Engineering & Construction (E&C)</h1>
              
              <h3 className="mb-4">Overview</h3>
              <p>Cooling towers are essential components in process industries for heat rejection from systems like condensers, chillers, and reactors. At Wasser Technochem (India) Ltd., we offer comprehensive engineering, procurement, and construction (EPC) services for FRP, RCC, wooden, and crossflow cooling towers, customized to suit varying industrial loads and climatic conditions.</p>
              <p>Our solutions ensure maximum thermal efficiency, low drift loss, and water conservation, helping clients meet their operational, environmental, and sustainability goals.</p>

              <h3 className="mb-4">Applications</h3>
              <p><i className="fa fa-bolt text-primary me-2"></i>Power plants and turbine cooling</p>
              <p><i className="fa fa-flask text-primary me-2"></i>Chemical and fertilizer plants</p>
              <p><i className="fa fa-industry text-primary me-2"></i>Refineries, steel, and cement industries</p>
              <p><i className="fa fa-tshirt text-primary me-2"></i>Textile and distillery cooling systems</p>
              <p><i className="fa fa-snowflake text-primary me-2"></i>Central HVAC and chilled water circuits</p>

              <h3 className="mb-4">Our Capabilities</h3>
              
              <h4 className="mb-3"><i className="fa fa-calculator text-primary me-2"></i>Thermal Design & Load Calculations</h4>
              <p>Based on process water temperature, ambient wet bulb, and desired cooling range.</p>

              <h4 className="mb-3"><i className="fa fa-cogs text-primary me-2"></i>Types of Cooling Towers:</h4>
              <p><i className="fa fa-wind text-primary me-2"></i>Induced draft or forced draft</p>
              <p><i className="fa fa-arrows-alt-v text-primary me-2"></i>Counterflow / crossflow</p>
              <p><i className="fa fa-th-large text-primary me-2"></i>Modular FRP cooling towers</p>
              <p><i className="fa fa-building text-primary me-2"></i>RCC structured towers for large capacity</p>

              <h4 className="mb-3"><i className="fa fa-tools text-primary me-2"></i>Civil + Mechanical + Electrical Scope:</h4>
              <p>Complete turnkey construction, including basins, decks, fan drives, motors, drift eliminators, fills, and valves.</p>

              <h4 className="mb-3"><i className="fa fa-volume-down text-primary me-2"></i>Noise Control & Drift Loss Reduction</h4>
              <p>Through aerodynamic fan and drift eliminator design.</p>

              <h4 className="mb-3"><i className="fa fa-microchip text-primary me-2"></i>Automation Options:</h4>
              <p>With temperature sensors, VFDs, and remote monitoring.</p>

              <h3 className="mb-4">Benefits</h3>
              <p><i className="fa fa-check-circle text-success me-2"></i>High cooling efficiency, even in peak summers</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Modular design for quick installation & expansion</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Corrosion-resistant materials ensure long life</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Low power consumption and minimal water losses</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Engineered to meet industrial norms (IS/CTI certified)</p>

              <h3 className="mb-4">Why WTIL?</h3>
              <p><i className="fa fa-star text-warning me-2"></i>Experience delivering cooling towers from 50 m³/hr to 4000+ m³/hr</p>
              <p><i className="fa fa-star text-warning me-2"></i>In-house structural and thermal design expertise</p>
              <p><i className="fa fa-star text-warning me-2"></i>Integrated E&C offering ensures single-point accountability</p>
              <p className="mb-5"><i className="fa fa-star text-warning me-2"></i>O&M and revamp support for old/inefficient towers</p>
            </div>

            <div className="col-lg-4">
              <ProjectSidebarComponent />
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default CoolingTowersEngineeringConstruction;
